import React from 'react';
import classnames from 'classnames';
import UIImage from 'components/UI/Image/Image';
import './Logo.scss';

type UILogoProps = {
  defaultImage?: string;
  url: string;
  className?: string;
  size?: 'small' | 'x-small';
  imagecachePreset?: string;
};

const cbn = 'ui-logo';

function UILogo({
  defaultImage,
  url,
  className,
  size,
  imagecachePreset = 'small',
  ...restProps
}: UILogoProps) {
  return (
    <UIImage
      {...restProps}
      className={classnames(cbn, className, `${cbn}--${size}`)}
      url={url || defaultImage}
      imagecachePreset={imagecachePreset}
    />
  );
}

UILogo.defaultProps = {
  className: null,
  size: 'small',
  defaultImage:
    'http://files-ben-productplacement-com.s3-website-us-east-1.amazonaws.com/default_missing_logo.jpg',
  url: null,
};

export default UILogo;
